// JS for Comparison
import $ from "jquery";

$(document).on("click", ".add-base-product", function (e) {
  e.preventDefault();
  var $thisbutton = $(this);
  const productID = $(this).data("product-id");
  const toggleData = $(".product-" + productID + "-input").data(
    "toggle-switch-options"
  );
  const toggleInput = $(".product-" + productID + "-input");
  const isChecked = $(".product-" + productID + "-input").is(":checked");
  const variationID =
    isChecked == true
      ? toggleData.variation_id
      : toggleData.variation_id_default;
  const productName = toggleData.product_name;
  const variationName =
    isChecked == true
      ? toggleData.variation_name
      : toggleData.variation_default_name;
  var data = {
    action: "ql_woocommerce_ajax_add_to_cart",
    product_id: productID,
    product_type: "base-plan",
    quantity: 1,
    variation_id: variationID,
  };
  $(document.body).trigger("adding_to_cart", [$thisbutton, data]);
  $.ajax({
    type: "post",
    url: wc_add_to_cart_params.ajax_url,
    data: data,
    beforeSend: function (response) {
      $thisbutton.removeClass("added").addClass("loading");
    },
    complete: function (response) {
      $thisbutton.addClass("added").removeClass("loading");
    },
    success: function (response) {
      refresh_notices();
      if (response.in_cart) {
        $(response.template).appendTo("body").modal("show");
      } else {
        $("#" + $thisbutton.attr("id") + "_text").html("Added");
        $thisbutton.addClass("disabled");
        $thisbutton.attr("aria-disabled", "true");
        window.location.href = EAPLUS_VARS.cart_url;
      }
      if (response.cart_total) {
      }
      if (response.error & response.plan_addons_url) {
        return;
      } else {
        $(document.body).trigger("added_to_cart", [
          response.fragments,
          response.cart_hash,
          $thisbutton,
        ]);
      }
    },
  });
  var dataLayer = (window.dataLayer = window.dataLayer || []);
  dataLayer.push({
    'event': "choose_plan",
    'client': EAPLUS_VARS.client_code,
    'tracking_code': EAPLUS_VARS.tracking_code,
    'discount': EAPLUS_VARS.discount,
    'conversion': "",
    'plan': productName,
    'coverage': variationName
  });
});

$(document).on("click", ".swap-base-product", function (e) {
  e.preventDefault();
  var $thisbutton = $(this);
  const productID = $(this).data("product-id");
  const toggleData = $(".product-" + productID + "-input").data(
    "toggle-switch-options"
  );
  const isChecked = $(".product-" + productID + "-input").is(":checked");
  const variationID =
    isChecked == true
      ? toggleData.variation_id
      : toggleData.variation_id_default;
  var data = {
    action: "ql_woocommerce_ajax_swap_base_product",
    product_id: productID,
    product_type: "base-plan",
    quantity: 1,
    variation_id: variationID,
  };
  $(document.body).trigger("adding_to_cart", [$thisbutton, data]);
  $.ajax({
    type: "post",
    url: wc_add_to_cart_params.ajax_url,
    data: data,
    beforeSend: function (response) {
      $thisbutton.removeClass("added").addClass("loading");
    },
    complete: function (response) {
      $thisbutton.addClass("added").removeClass("loading");
    },
    success: function (response) {
      refresh_notices();
      if (response.in_cart) {
        //$('#<?php echo $block_id; ?>').append(response.template).modal('show');
        $("body").append(response.template).modal("show");
        //$(response.template).appendTo('body').modal('show');
      } else {
        $("#" + $thisbutton.attr("id") + "_text").html("Added");
        $("#product-info-modal").modal("hide");
        window.location.href = EAPLUS_VARS.cart_url;
      }
      if (response.error & response.plan_addons_url) {
        return;
      } else {
        $(document.body).trigger("added_to_cart", [
          response.fragments,
          response.cart_hash,
          $thisbutton,
        ]);
      }
    },
  });
});

$(document).on("change", ".switch-input", function () {
  var current_element = $(this);
  var current_state = $(this).is(":checked");

  const isChecked = $(this).is(":checked");
  const toggleData = $(this).data("toggle-switch-options");
  const productinCart = toggleData.product_in_cart;
  const variationinCart = toggleData.variation_in_cart;
  if (isChecked) {
    if (productinCart == toggleData.product_id) {
      if (variationinCart == toggleData.variation_id) {
        $("a.btn.product-btn-" + toggleData.product_id)
          .addClass("disabled")
          .html("Added to cart");
        $("a.add-btn.product-btn-" + toggleData.product_id)
          .addClass("disabled")
          .removeClass("other-variation")
          .find("h2")
          .html(toggleData.product_name + " " + toggleData.variation_name);
      } else {
        $("a.btn.product-btn-" + toggleData.product_id)
          .removeClass("disabled")
          .html("Update Cart");
        $("a.add-btn.product-btn-" + toggleData.product_id)
          .removeClass("disabled")
          .addClass("other-variation")
          .find("h2")
          .html(
            "Update to " +
              toggleData.product_name +
              " " +
              toggleData.variation_name
          );
      }
    }
    $(".product-price-" + toggleData.product_id).html(
      toggleData.variation_price
    );
    $(".discount-product-price-" + toggleData.product_id).html(
      "$" +
        (
          toggleData.variation_price_raw - toggleData.variation_discount_amount
        ).toFixed(2)
    );
    $("a.product-btn-" + toggleData.product_id).attr(
      "href",
      function (i, href) {
        return (
          EAPLUS_VARS.enroll_now_page_url +
          "?add-to-cart=" +
          toggleData.product_id +
          "&variation_id=" +
          toggleData.variation_id
        );
      }
    );
  } else {
    if (productinCart == toggleData.product_id) {
      if (variationinCart == toggleData.variation_id_default) {
        $("a.btn.product-btn-" + toggleData.product_id)
          .addClass("disabled")
          .html("Added to cart");
        $("a.add-btn.product-btn-" + toggleData.product_id)
          .addClass("disabled")
          .removeClass("other-variation")
          .find("h2")
          .html(
            toggleData.product_name + " " + toggleData.variation_default_name
          );
      } else {
        $("a.btn.product-btn-" + toggleData.product_id)
          .removeClass("disabled")
          .html("Update Cart");
        $("a.add-btn.product-btn-" + toggleData.product_id)
          .removeClass("disabled")
          .addClass("other-variation")
          .find("h2")
          .html(
            "Update to " +
              toggleData.product_name +
              " " +
              toggleData.variation_default_name
          );
      }
    }
    $(".product-price-" + toggleData.product_id).html(toggleData.price);
    $(".discount-product-price-" + toggleData.product_id).html(
      "$" + (toggleData.price_raw - toggleData.discount_amount).toFixed(2)
    );
    $("a.product-btn-" + toggleData.product_id).attr(
      "href",
      function (i, href) {
        return (
          EAPLUS_VARS.enroll_now_page_url +
          "?add-to-cart=" +
          toggleData.product_id +
          "&variation_id=" +
          toggleData.variation_id_default
        );
      }
    );
  }

  sync_toggle(current_element, current_state);
});

function sync_toggle(element, state) {
  var toggles = $(".switch-input").not(element);
  $(toggles).each(function (index) {
    var toggle = $(this);
    if ($(toggle).is(":checked") != state) {
      $(toggle).prop("checked", state);
    }
    const isChecked = $(toggle).is(":checked");
    const toggleData = $(toggle).data("toggle-switch-options");
    const productinCart = toggleData.product_in_cart;
    const variationinCart = toggleData.variation_in_cart;
    if (isChecked) {
      if (productinCart == toggleData.product_id) {
        if (variationinCart == toggleData.variation_id) {
          $("a.btn.product-btn-" + toggleData.product_id)
            .addClass("disabled")
            .html("Added to cart");
          $("a.add-btn.product-btn-" + toggleData.product_id)
            .addClass("disabled")
            .removeClass("other-variation")
            .find("h2")
            .html(toggleData.product_name + " " + toggleData.variation_name);
        } else {
          $("a.btn.product-btn-" + toggleData.product_id)
            .removeClass("disabled")
            .html("Update Cart");
          $("a.add-btn.product-btn-" + toggleData.product_id)
            .removeClass("disabled")
            .addClass("other-variation")
            .find("h2")
            .html(
              "Update to " +
                toggleData.product_name +
                " " +
                toggleData.variation_name
            );
        }
      }
      $(".product-price-" + toggleData.product_id).html(
        toggleData.variation_price
      );
      $(".discount-product-price-" + toggleData.product_id).html(
        "$" +
          (
            toggleData.variation_price_raw -
            toggleData.variation_discount_amount
          ).toFixed(2)
      );
      $("a.product-btn-" + toggleData.product_id).attr(
        "href",
        function (i, href) {
          return (
            EAPLUS_VARS.enroll_now_page_url +
            "?add-to-cart=" +
            toggleData.product_id +
            "&variation_id=" +
            toggleData.variation_id
          );
        }
      );
    } else {
      if (productinCart == toggleData.product_id) {
        if (variationinCart == toggleData.variation_id_default) {
          $("a.btn.product-btn-" + toggleData.product_id)
            .addClass("disabled")
            .html("Added to cart");
          $("a.add-btn.product-btn-" + toggleData.product_id)
            .addClass("disabled")
            .removeClass("other-variation")
            .find("h2")
            .html(
              toggleData.product_name + " " + toggleData.variation_default_name
            );
        } else {
          $("a.btn.product-btn-" + toggleData.product_id)
            .removeClass("disabled")
            .html("Update Cart");
          $("a.add-btn.product-btn-" + toggleData.product_id)
            .removeClass("disabled")
            .addClass("other-variation")
            .find("h2")
            .html(
              "Update to " +
                toggleData.product_name +
                " " +
                toggleData.variation_default_name
            );
        }
      }
      $(".product-price-" + toggleData.product_id).html(toggleData.price);
      $(".discount-product-price-" + toggleData.product_id).html(
        "$" + (toggleData.price_raw - toggleData.discount_amount).toFixed(2)
      );
      $("a.product-btn-" + toggleData.product_id).attr(
        "href",
        function (i, href) {
          return (
            EAPLUS_VARS.enroll_now_page_url +
            "?add-to-cart=" +
            toggleData.product_id +
            "&variation_id=" +
            toggleData.variation_id_default
          );
        }
      );
    }
  });
}

var can_toggle = true;
if (can_toggle) {
  $(".switch-input").each(function () {
    if ($(this).is(":checked")) {
      sync_toggle($(this), $(this).is(":checked"));
      can_toggle = false;
    }
  });
}

//Setup AJAX call refreshing notices
var $notices_refresh = {
  url: wc_add_to_cart_params.wc_ajax_url
    .toString()
    .replace("%%endpoint%%", "get_notices"),
  type: "GET", // might deliver cached data
  timeout: 5000,
  success: function (data) {
    if (data && data.notices) {
      // Remove existing notices
      $(".woocommerce-error, .woocommerce-message, .woocommerce-info").remove();
      // Add new notices
      $(".woocommerce-notices-wrapper:first").prepend(data.notices);

      $(document.body).trigger("wc_notices_refreshed");
    }
  },
  error: function () {
    $(document.body).trigger("wc_notices_ajax_error");
  },
};

/* Named callback for refreshing notices */
function refresh_notices() {
  $.ajax($notices_refresh);
}

// required to refresh woocommerce notices for OceanWP ajax add to cart.
$("body").on("adding_to_cart", function () {
  refresh_notices();
});

$("body").on("wc_notices_refreshed", function () {});
